import React, {useRef, useState} from "react";
import CustomDiv from "../CustomDiv";
import brandLogo from "../../Assets/griffon.jpeg";
import SignIn from "../../Authentication/SignInPage";
import TemporaryDrawer from "./AddToCart";
import {useNavigate} from "react-router-dom";
import Text from "../Text";
import {useMutation, useQuery} from "react-query";
import {myWishList} from "../../Services/WishList";
import {Store} from "../../Services/Store";
import {API_URLS} from "../../Config/API_URLS";
import axiosInstance from "../../Config/axios";
import {useEffect} from "react";

import wishlistLogo from "../../Assets/wishlist.svg";
import defg from "../../Assets/defg.webp";
import {
  Autocomplete,
  Badge,
  Box,
  Collapse,
  Drawer,
  IconButton,
  List,
  ListItemButton,
  ListItemIcon,
  Skeleton,
  TextField,
  Typography,
} from "@mui/material";
import {
  ExpandLess,
  ExpandMore,
  KeyboardArrowDownOutlined,
  MenuTwoTone,
  ArrowDropDownOutlined,
  Search,
} from "@mui/icons-material";
import {categoryListFn} from "../../Services/CategoryList";
import {useDispatch} from "react-redux";
import {setThemeMode} from "../../Redux/Actions/ThemeMode";
import {productsFn} from "../../Services/Products";
import classNames from "classnames";

const Headers = () => {
  const [open, setOpen] = useState(false);
  const [collapse, setCollapse] = useState([]);
  const [store, setStore] = useState([]);
  const [spices, setSpices] = React.useState([]);
  const [search, setSearch] = useState(false);
  const [value, setValue] = useState("");
  const [header, setHeader] = useState("");
  const [serchProduct, setSerchProduct] = useState([]);
  const [serch, setSerch] = useState("");
  const listEndRef = useRef(null);
  const [activeItem, setActiveItem] = useState(0);
  const [menu, setMenu] = useState(false);

  const [productId, setProductId] = useState({});
  // const {mutate: allProducts} = useMutation(productsFn, {
  //   onSuccess: (response) => {
  //     setSpices(response.data.data.product_list);
  //   },
  // });

  const CustomizationHeader = () => {
    axiosInstance
      .get(API_URLS.HeaderCustomization)
      .then((response) => {
        setHeader(response?.data?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    CustomizationHeader();
  }, []);

  const SerchData = () => {
    const reqbody = new FormData();
    reqbody.append("search", serch);
    axiosInstance
      .post(API_URLS.Serch, reqbody)
      .then((response) => {
        setSerchProduct(response?.data?.data?.product_list);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  React.useEffect(
    () => {
      serch && SerchData();
    },
    // eslint-disable-next-line
    [serch]
  );

  const products = spices?.map((product) => {
    return {
      image: product.image,
      variant: product.variant_name,
      sub_category: product.sub_category,
      id: product.id,
      vid: product?.variant_id,
    };
  });

  const handleClick = (id) => {
    setCollapse((collapse) => [...collapse, id]);
  };
  const handleClose = (id) => {
    setCollapse(collapse?.filter((item) => item !== id));
  };
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const {data} = useQuery(["wishList"], () => myWishList());

  const {data: mainCategoryList} = useQuery(
    ["mainCategoryList"],
    () => categoryListFn(),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  );

  const handleChange = (event) => {
    navigate(`/product/${event.currentTarget.lastChild.innerHTML}`);
    sessionStorage.clear();
    setOpen(false);
  };

  const handleLogin = () => {
    dispatch(setThemeMode(true));
  };
  const handleKeyDown = (event, option) => {
    const {key} = event;

    if (key === "Enter") {
      navigate(`/product/${productId?.id}/${productId?.vid}`);

      console.log("productID", option);
    }
    // navigate(`/product/${option?.id}/${option?.vid}`);
  };
  const handleListItemKeyDown = (event, listId) => {
    const {key} = event;
    document
      .getElementById(serchProduct?.[activeItem]?.variant_id)
      ?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    if (key === "ArrowDown") {
      activeItem !== serchProduct?.length - 1 &&
        setActiveItem((prevIndex) => prevIndex + 1);
    } else if (key === "ArrowUp") {
      activeItem !== 0 && setActiveItem((prevIndex) => prevIndex - 1);
    } else if (key === "Enter") {
      serchProduct?.[activeItem]?.id &&
        serchProduct?.[activeItem]?.variant_id &&
        navigate(
          `/product/${serchProduct?.[activeItem]?.id}/${serchProduct?.[activeItem]?.variant_id}`
        );

      setSerch("");
    }
  };
  const handleLooseFocus = () => {
    setTimeout(() => {
      setMenu(false);
    }, 500);
    return clearTimeout;
  };

  return (
    <CustomDiv className="lg:h-0 h-[25px] sticky z-50 shadow">
      <CustomDiv className="flex flex-col justify-between items-center fixed z-50  bg-white bg-opacity- text-black backdrop-blur w-full px-[4%] lg:px-[8%]">
        <CustomDiv className="flex items-center justify-between w-full">
          <span className="flex items-center gap-5">
            <img
              src={brandLogo}
              alt=""
              className="relative h-20 cursor-pointer"
              onClick={() => navigate("/")}
            />
          </span>

          <span className="bg-white !rounded-full py-2 outline-none shadow dropdown border-stone-50 lg:flex justify-between hidden items-center">
            <input
              className="!w-[400px] outline-none bg-transparent px-4"
              type="text"
              value={serch}
              placeholder="Search for Products"
              onChange={(e) => {
                setSerch(e.target.value);
                setSerchProduct([]);
              }}
            />
            <span className="pr-3">
              <Search />
            </span>

            {serch && (
              <List className="!absolute !hidden lg:!block !h-fit top-0 !shadow-md border z-50 rounded !p-0">
                <span
                  onKeyDown={(event) => handleListItemKeyDown(event, 1)}
                  className={classNames(
                    "bg-white lg:flex outline-none hidden shadow dropdown border-stone-50 px-3 py-2 justify-between items-center"
                  )}
                >
                  <input
                    className={classNames(
                      "!w-[388px] outline-none bg-transparent px-3"
                    )}
                    autoFocus
                    value={serch}
                    type="text"
                    placeholder="Search for Products, Brands, Offers"
                    onBlur={() => {
                      setTimeout(() => {
                        setSerch("");
                        setSerchProduct([]);
                      }, 500);
                    }}
                    onChange={(e) => {
                      setSerch(e.target.value);
                      setSerchProduct([]);
                    }}
                  />
                  <Search />
                </span>

                <div className="overflow-y-auto pt-px bg-white !max-h-[390px]">
                  {true ? (
                    serchProduct?.map((item, index) => {
                      return (
                        <>
                          <ListItemButton
                            ref={listEndRef}
                            id={item.variant_id}
                            onClick={() => {
                              navigate(
                                `/product/${item.id}/${item.variant_id}`
                              );
                            }}
                            className={classNames(
                              activeItem === index &&
                                "bg-gradient-to-t from-green-50 !text-black to-green-300"
                            )}
                            selected={activeItem === index}
                          >
                            <ListItemIcon>
                              <img
                                src={item.variant_image || item.image}
                                alt=""
                                className="h-12 rounded"
                              />
                            </ListItemIcon>
                            <span className="flex flex-col">
                              <span>{item.variant_name}</span>
                              <span>{item.brand_name}</span>
                            </span>
                          </ListItemButton>
                        </>
                      );
                    })
                  ) : (
                    <>
                      {[1, 2, 3, 4, 5, 6].map((item) => {
                        return (
                          <ListItemButton key={item} className="flex gap-5 p-2">
                            <Skeleton className="!scale-100 !h-12 !w-12" />
                            <span className="flex flex-col w-full">
                              <Skeleton className="w-4/5" />
                              <Skeleton className="w-1/2" />
                            </span>
                          </ListItemButton>
                        );
                      })}
                    </>
                  )}
                </div>
              </List>
            )}
          </span>
          <span className="flex items-center gap-4 lg:gap-7">
            <SignIn />
            <Badge
              className="!bg-black"
              badgeContent={
                localStorage.getItem("token")
                  ? data?.data?.data?.wishlist_product_list?.length
                  : 0
              }
              color="primary"
            >
              <img
                alt=""
                src={
                  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRJoia48EP0RFCp6JuIODLjXJMfe0qE3m58yDQ2CiLsl_fKh9-VPfOKW21z7tefUiY8cRs&usqp=CAU"
                }
                className="cursor-pointer h-7"
                onClick={() =>
                  localStorage.getItem("token")
                    ? navigate("/wish-list")
                    : handleLogin()
                }
              />
            </Badge>

            <TemporaryDrawer />

            <Badge className="!bg-black" color="primary">
              <img
                alt=""
                src="https://www.shutterstock.com/image-vector/wallet-icon-vector-260nw-1377533453.jpg"
                className="h-11 cursor-pointer"
                onClick={() =>
                  localStorage.getItem("token")
                    ? navigate("/wallet")
                    : handleLogin()
                }
              />
            </Badge>

            <IconButton onClick={() => setOpen(true)}>
              <MenuTwoTone className="!block lg:!hidden !text-black" />
            </IconButton>
            <Drawer anchor="right" open={open} onClose={() => setOpen(false)}>
              <CustomDiv className="">
                <List className="!pr-0">
                  <span className="!p-4 flex justify-center">
                    <Autocomplete
                      options={products || []}
                      autoHighlight
                      size="small"
                      className="Product"
                      freeSolo
                      sx={{width: 260}}
                      onChange={handleChange}
                      disableClearable
                      getOptionLabel={(option) => option?.variant}
                      renderOption={(props, option) => (
                        <Box
                          component="li"
                          sx={{"& > img": {mr: 2, flexShrink: 0}}}
                          {...props}
                          onClick={() => {
                            navigate(`/product/${option?.id}/${option?.vid}`);
                            setSearch(false);
                          }}
                          onKeyDown={handleKeyDown(option)}
                        >
                          <img
                            loading="lazy"
                            width="50"
                            src={option.image}
                            srcSet={option?.image}
                            alt=""
                          />

                          <span className="flex flex-col">
                            <span className="text-lg">{option?.variant}</span>
                            <span className="text-sm">
                              {option?.sub_category}
                            </span>
                          </span>

                          <span id="variant_id" hidden>
                            {option?.id}
                          </span>
                        </Box>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Search Products"
                          inputProps={{
                            ...params?.inputProps,
                            autoComplete: "new-password", // disable autocomplete and autofill
                          }}
                        />
                      )}
                    />
                  </span>

                  <ListItemButton
                    onClick={() =>
                      navigate("/all-products", {
                        state: {from: "allproduct"},
                      })
                    }
                    className="!flex  !justify-between !w-full cursor-pointer"
                  >
                    All Products
                  </ListItemButton>
                  {mainCategoryList?.data?.data?.main_category_list?.map(
                    (product1) => {
                      return (
                        <>
                          <ListItemButton
                            onClick={() => {
                              return (
                                <>
                                  {collapse.indexOf(product1?.id) === -1
                                    ? handleClick(product1?.id)
                                    : handleClose(product1?.id)}
                                </>
                              );
                            }}
                            className="!flex !justify-between !w-full"
                          >
                            <span>{product1?.category}</span>

                            {collapse ? <ExpandMore /> : <ExpandLess />}
                          </ListItemButton>
                          <Collapse
                            in={collapse?.indexOf(product1?.id) !== -1}
                            className=""
                          >
                            <List>
                              {product1?.sub_category_list?.map(
                                (subCategory) => {
                                  return (
                                    <ListItemButton
                                      className="!flex !pl-8 !justify-between !w-full"
                                      onClick={() =>
                                        navigate(`/all-products`, {
                                          state: {
                                            from: "subCategory",
                                            subCategory: subCategory?.id,
                                          },
                                        })
                                      }
                                    >
                                      {subCategory?.subcategory}
                                    </ListItemButton>
                                  );
                                }
                              )}
                            </List>
                          </Collapse>
                        </>
                      );
                    }
                  )}
                </List>
              </CustomDiv>
            </Drawer>
          </span>
        </CustomDiv>
      </CustomDiv>
      <CustomDiv className="hidden pl-10  sticky top-0 z-20 lg:flex gap-5 lg:py-4 px-2 mb-1 bg-white shadow justify-start items-start lg:pt-[95px]">
        <div
          onClick={() =>
            navigate("/all-products", {
              state: {from: "allproduct"},
            })
          }
          className="flex flex-col justify-center items-center gap-2"
        >
          {/* <img src="https://m.media-amazon.com/images/I/719ACxhj0lL.jpg" alt='' className='rounded-full w-16 h-16 object-cover border-2 border-gray-800'/> */}
          <p className="text-sm font-bold text-gray-800 cursor-pointer">
            All Products
          </p>
        </div>

        {mainCategoryList?.data?.data?.main_category_list
          ?.slice(0, 6)
          ?.map((product) => {
            return (
              <div className="group inline-block relative">
                <Typography className="flex flex-col justify-center items-center gap-2">
                  {/* <img src={product.image} alt='' className='rounded-full w-16 h-16 object-cover border-2 border-gray-800'/> */}
                  <p
                    className="text-sm flex items-center font-bold text-gray-800 cursor-pointer"
                    onMouseEnter={() => setMenu(true)}
                  >
                    {product?.category}
                    <ArrowDropDownOutlined />
                  </p>
                </Typography>
                <ul
                  className={classNames(
                    "absolute   hidden w-96 p-2 z-50 shadow bg-white bg-opacity-80 backdrop-blur text-black border-t-4 group-hover:grid-cols-2 border-[#306BDE] rounded-sm ",
                    menu && "group-hover:grid"
                  )}
                >
                  {product?.sub_category_list?.map((subCategory) => {
                    return (
                      <li
                        key={subCategory.id}
                        className="p-2 flex flex-col gap-2 cursor-pointer hover:underline"
                        onClick={() => {
                          navigate(`/all-products`, {
                            state: {
                              from: "subCategory",
                              subCategory: subCategory?.id,
                            },
                          });
                          handleLooseFocus();
                        }}
                      >
                        {subCategory?.subcategory}
                      </li>
                    );
                  })}
                  <img src={product?.image} alt="s" className="w-full" />
                </ul>
              </div>
            );
          })}
      </CustomDiv>
    </CustomDiv>
  );
};

export default Headers;
